import { render, staticRenderFns } from "./ProductVitalInfoForm.vue?vue&type=template&id=2a489df4&scoped=true&"
import script from "./ProductVitalInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProductVitalInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductVitalInfoForm.vue?vue&type=style&index=0&id=2a489df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a489df4",
  null
  
)

export default component.exports